(() => {
  if (customElements.get('offers-tilt')) return;

  customElements.define('offers-tilt', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      const motion = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
      const resets = [];

      this.querySelectorAll('.offers-card-wrap').forEach(wrapper => {
        const card = wrapper.querySelector('a.offers-card');
        if (!card) return;
        let frame = 0;
        let point;

        const reset = () => {
          cancelAnimationFrame(frame);
          frame = 0;
          card.classList.remove('is-hovered');
          ['--offer-tilt-x', '--offer-tilt-y', '--offer-shine-x', '--offer-shine-y'].forEach(name => card.style.removeProperty(name));
        };
        resets.push(reset);

        const update = () => {
          frame = 0;
          if (!motion.matches) return reset();
          const bounds = wrapper.getBoundingClientRect();
          if (!bounds.width || !bounds.height) return reset();
          const x = Math.max(0, Math.min(1, (point.x - bounds.left) / bounds.width));
          const y = Math.max(0, Math.min(1, (point.y - bounds.top) / bounds.height));
          card.style.setProperty('--offer-tilt-x', `${((.5 - y) * 6).toFixed(2)}deg`);
          card.style.setProperty('--offer-tilt-y', `${((x - .5) * 8).toFixed(2)}deg`);
          card.style.setProperty('--offer-shine-x', `${(x * 100).toFixed(1)}%`);
          card.style.setProperty('--offer-shine-y', `${(y * 100).toFixed(1)}%`);
          card.classList.add('is-hovered');
        };
        const move = event => {
          if (!motion.matches || event.pointerType === 'touch') return reset();
          point = { x: event.clientX, y: event.clientY };
          if (!frame) frame = requestAnimationFrame(update);
        };

        wrapper.addEventListener('pointerenter', move, { signal, passive: true });
        wrapper.addEventListener('pointermove', move, { signal, passive: true });
        wrapper.addEventListener('pointerleave', reset, { signal });
        wrapper.addEventListener('pointercancel', reset, { signal });
      });

      this.reset = () => resets.forEach(reset => reset());
      motion.addEventListener('change', this.reset, { signal });
      window.addEventListener('blur', this.reset, { signal });
      document.addEventListener('visibilitychange', this.reset, { signal });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.reset?.();
    }
  });
})();
